import { create } from 'zustand';
import { PRD5050_R01ResultDto } from './Dto_PRD5050_R01';

// 검색 조건(필터) 타입 정의
export interface PRD5050_R01Filter {
	compCd: string;        // 사업장
	year: number;          // 조회 연도
	workplaceCd: string;   // 공정
	itemGroup: string;     // 품목그룹
	itemCd: string;        // 품목코드(선택)
	itemNm: string;        // 품목명(팝업 표시용, 선택)
}

// zustand 스토어가 관리할 상태와 액션(함수)들의 타입 정의
export interface Store_PRD5050_R01 {
	PRD5050_R01Filter: PRD5050_R01Filter; // 현재 적용된 검색 조건
	setPRD5050_R01Filter: (filter: Partial<PRD5050_R01Filter>) => void; // 검색 조건 일부/전체 갱신 함수

	// 결과: 월별 12행 단일 배열
	PRD5050_R01List: PRD5050_R01ResultDto[]; // 조회 결과(월별 12행)
	setPRD5050_R01List: (list: PRD5050_R01ResultDto[]) => void; // 조회 결과 갱신 함수

	initData: () => void; // 화면 초기화(필터/리스트 모두 기본값으로 되돌림) 함수
}

// 검색 조건의 기본값 (연도는 오늘 기준 현재 연도로 초기화)
export const defaultPRD5050_R01Filter: PRD5050_R01Filter = {
	compCd: '',                          // 전체 사업장
	year: new Date().getFullYear(),      // 현재 연도
	workplaceCd: '',                     // 전체 공정
	itemGroup: '',                       // 전체 품목그룹
	itemCd: '',                          // 품목코드 미지정
	itemNm: '',                          // 품목명 미지정
};

// PRD5050_R01 화면 전용 zustand 스토어 생성
export const usePRD5050_R01Store = create<Store_PRD5050_R01>((set) => ({
	PRD5050_R01Filter: defaultPRD5050_R01Filter, // 초기 필터값
	setPRD5050_R01Filter: (filter) => set((state) => ({
		PRD5050_R01Filter: { ...state.PRD5050_R01Filter, ...filter }, // 기존 필터에 변경분만 병합
	})),

	PRD5050_R01List: [], // 초기 결과 리스트는 빈 배열
	setPRD5050_R01List: (list) => set({ PRD5050_R01List: list }), // 결과 리스트 통째로 교체

	initData: () => set({
		PRD5050_R01Filter: defaultPRD5050_R01Filter, // 필터 초기화
		PRD5050_R01List: [],                         // 결과 리스트 초기화
	}),
}));
